import React, { useState, useRef, useEffect } from "react";
import "./SearchRdv.css";
import {
  Form,
  Button,
  Row,
  OverlayTrigger,
  Tooltip,
  Alert,
  Col,
  Container,
} from "react-bootstrap";

import Select, { components } from "react-select";
import StepperComponent from "../Stepper/Stepper";
import { DatePickerInput } from "rc-datepicker";
import "rc-datepicker/lib/style.css";
import ServiceMember from "../Services/ServiceMember";
import { formatVilleToLabelValue } from "../../utils/utils";
import ServiceSearchRdv from "./ServiceSearchRdv/ServiceSearchRdv";
import ModalRdv from "./ModalRdv";
import moment from "moment";
import { lighten } from "@material-ui/core";
import ModalPeAcharger from "./ModalPeAcharger";
const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);

const SearchRdv = (props) => {
  useEffect(() => {
    handleNext();
    handleShearch();
  }, []);
  const [date, setDate] = useState(new Date().toString());
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [list, setList] = useState([]);
  const [typeC, setTaypeCs] = useState(
    JSON.parse(sessionStorage.getItem("Type")) &&
      JSON.parse(sessionStorage.getItem("Type")).type
  );

  const ref = useRef(null);
  useEffect(() => {
    setDateItem();
  }, [date]);
  const setDateItem = () => {
    sessionStorage.setItem(
      "DateRdv",
      JSON.stringify({
        dateRdv: date,
      })
    );
  };

  const data = [{ label: "Moi Meme" }, { label: "Persone Acharger" }];
  const [formattedVille, setFormattedVille] = useState();
  const [type, setType] = useState();
  const [city, setCity] = useState("");
  const [hour, setHour] = useState("");
  const selectRef = useRef("");
  const clearCity = () => {
    setCity("");
    selectRef.current.select.clearValue();
  };
  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const [activeStep, setActiveStep] = useState(0);
  const handleNext = () => {
    setActiveStep(1);
  };
  const [listHours, setListHours] = useState([]);
  //listHours && console.log("listHours matin", listHours[0]);
  const listHourTranche = [];
  //console.log(date, JSON.parse(sessionStorage.getItem("healthPro")));
  const handleShearch = () => {
    //console.log(JSON.parse(sessionStorage.getItem("healthPro")).id);
    ServiceSearchRdv.postdate(
      date,
      JSON.parse(sessionStorage.getItem("healthId"))
    ).then((res) => {
      res &&
        res.data.map((item1, i) => {
          listHourTranche.push({
            id: item1.id,
            designation: item1.designation,
            plannings: {
              Matin: Object.values(item1)
                .slice(4)
                .filter((item) =>
                  moment(item, "HHmm").isBetween(
                    moment("06:00", "HHmm"),
                    moment("13:00", "HHmm"),
                    undefined,
                    "[]"
                  )
                ),
              Midi: Object.values(item1)
                .slice(4)
                .filter((item) =>
                  moment(item, "HHmm").isBetween(
                    moment("13:30", "HHmm"),
                    moment("18:30", "HHmm"),
                    undefined,
                    "[]"
                  )
                ),
              Soir: Object.values(item1)
                .slice(4)
                .filter(
                  (item) =>
                    moment(item, "HH:mm").isAfter(moment("18:30", "HH:mm")) ||
                    moment(item, "HH:mm").isBefore(moment("06:00", "HH:mm"))
                ),
            },
          });
        });
      setListHours(listHourTranche);
    });
  };

  const GetHour = (id) => {
    setHour(document.getElementById(id).innerText);
  };

  // Modale

  const [showrdv, setShowrdv] = useState(false);
  const HandleShow = () => setShowrdv(true);
  const Toggle = () => {
    setShowrdv(false);
  };

  // ModalePeAcharger

  const [showPeAcharger, setShowPeAcharger] = useState(false);

  const ModalePeAcharger = (item) => {
    if (item === "Personne à charge") {
      setShowPeAcharger(true);
    }
  };
  const TogglePeAcharger = () => {
    setShowPeAcharger(false);
  };
  // get labo info
  const lieux = JSON.parse(sessionStorage.getItem("lieux"));

  // console.log("hour", hour);
  // console.log(date);

  // console.log("times", list.capacity);

  return (
    <>
      <ModalPeAcharger show={showPeAcharger} Toggle={TogglePeAcharger} />
      <ModalRdv
        show={showrdv}
        Toggle={Toggle}
        date={date}
        hour={hour}
        idPlan={listHours.length == 1 && listHours[0].id}
      />
      <Container>
        <div className="SearchRdv">
          <h2>Prise de rendez-vous en ligne</h2>
          <hr />
          <StepperComponent activeStep={activeStep} />
          <Row>
            <Col lg={6} xs={12}>
              {/* <h6>Selectionner votre ville pour les prélèvement à domicile.</h6> */}
              <Form.Label className="mt-4 mb-0">Patient :</Form.Label>
              <Form.Group controlId="calendar.SelectCustom">
                <Form.Control
                  className="mt-3"
                  as="select"
                  custom
                  required
                  style={{
                    width: "70%",
                  }}
                  defaultValue="Moi Même"
                  onChange={(e) => {
                    ModalePeAcharger(e.target.value);
                  }}
                >
                  <option>Moi Même</option>
                  <option>Personne à charge</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col lg={6} xs={12}>
              <h6 className="mt-4 mb-0">Choisir une date : </h6>
              <div className=" d-inline-flex">
                <DatePickerInput
                  minDate={new Date()}
                  onChange={(date) => setDate(date.toString())}
                  value={date}
                  className="my-custom-datepicker-component"
                />
              </div>
              <button
                id="valider"
                className="btn2 home"
                style={{
                  marginLeft: "20px",
                  width: "90px",
                  height: "38px",
                  background: typeC === "Covid" ? "#c4e538" : "#2ecc71",
                }}
                onClick={() => {
                  handleShearch();
                }}
              >
                Valider
              </button>
            </Col>
          </Row>
          {listHours.length ? <h5>Choisir l'heure : </h5> : ""}
          <Row className="justify-content-md-center">
            {listHours.length ? (
              listHours.map((data) => (
                <Row className="cardR" id="message">
                  {Object.keys(data.plannings).map((planningName, j) => (
                    <Col lg={4} xs={12} className="text-center">
                      <h3 className="text-center">
                        {planningName === "Midi"
                          ? `Aprés-${planningName}`
                          : planningName}
                      </h3>
                      {data.plannings[planningName].length > 0 ? (
                        data.plannings[planningName].map((planningHours, i) => (
                          <span
                            id={i + planningName}
                            className="d-inline-block"
                            onClick={() => {
                              HandleShow();
                              GetHour(i + planningName);
                            }}
                          >
                            {planningHours}
                          </span>
                        ))
                      ) : (
                        <Alert variant="warning" className="text-center mt-4">
                          Aucun RDV n'est disponible!
                        </Alert>
                      )}
                    </Col>
                  ))}
                </Row>
              ))
            ) : (
              <Col lg={8} xs={12}>
                <Alert variant="danger" className="text-center mt-4">
                  Aucun RDV n'est disponible pour cette date!
                </Alert>
              </Col>
            )}
          </Row>
          <Row>
            <Col lg={6} xs={12}>
              <div>
                <h6 style={{ marginTop: "50px", marginBottom: "20px" }}>
                  Conditions pré-analytiques
                </h6>
                <p>
                  Votre confirmation de rendez-vous contiendra des informations
                  sur l’emplacement exact et les directives à suivre à votre
                  arrivée. Notez qu’un cellulaire sera nécessaire le jour de
                  votre rendez-vous.
                </p>
              </div>
            </Col>
            <Col lg={6} xs={12}>
              <div className="card">
                <h4>Vous avez des questions?</h4>
                <p>
                  N'hésitez pas à contacter le numéro{" "}
                  <span
                    style={{
                      fontWeight: "700",
                      color: "#2ecc71",
                    }}
                  >
                    {lieux && lieux.tel}
                  </span>
                  . Du lundi au vendredi de 9 h à 18 h et samedi de 9 h et 13 h.
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
};

export default SearchRdv;
